import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=c0832bce&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=c0832bce&prod&lang=scss"
import style1 from "./detail.vue?vue&type=style&index=1&id=c0832bce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0832bce",
  null
  
)

export default component.exports